import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Awaits `task`, then always runs `settle`. Components call this rather than
 * writing try/finally inline, which the React Compiler can't lower yet (it
 * skips the whole component).
 */
export async function runThenSettle(task: () => Promise<void> | void, settle: () => void) {
  try {
    await task();
  } finally {
    settle();
  }
}
